"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var contains = function contains(stack, needle) {
  for (var i = 0; i < stack.length; i++) {
    if (stack[i] == needle) {
      return true;
    }
  }
  return false;
};

/**
 * Returns an object that holds the items
 * asociated with the value.
 * @param  {String|Number|String[]|Number[]} value
 * @param  {Object} dataMap
 * @return {Object}
 */

function getValueMap(_ref) {
  var value = _ref.value,
      dataMap = _ref.dataMap,
      oldValueMap = _ref.oldValueMap;

  if (value == null) {
    return oldValueMap;
  }

  var valueMap = _extends({}, oldValueMap);

  value = Array.isArray(value) ? value : [value];

  // clean up extra values which are not in the "value" array
  valueMap = Object.keys(valueMap).reduce(function (acc, id) {
    if (contains(value, id)) {
      acc[id] = valueMap[id];
    }
    return acc;
  }, {});

  value.forEach(function (id) {
    if (dataMap && dataMap[id]) {
      valueMap[id] = dataMap[id];
    }
  });

  return valueMap;
}

exports.default = getValueMap;